// @mention detection for comments. The composer is contentEditable HTML, so we
// resolve mentions by matching "@<roster name>" in the comment's plain text
// against the known roster (case-insensitive) rather than a fragile inline
// autocomplete. Returns the matched user ids; the backend notifies them.

export interface MentionUser {
  id: string;
  name: string;
}

/** Plain text from a comment HTML string (best-effort, inert parse). */
export function commentPlainText(html: string): string {
  if (typeof DOMParser === "undefined") return html.replace(/<[^>]+>/g, " ");
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent ?? "";
}

/** Roster users whose name appears after an "@" in the text. Longest names are
 *  matched first so "@John Smith" matches the full name, not a "@John". */
export function detectMentions(html: string, roster: MentionUser[]): MentionUser[] {
  const text = commentPlainText(html).toLowerCase();
  if (!text.includes("@")) return [];
  const byLongest = [...roster].sort((a, b) => b.name.length - a.name.length);
  const hit: MentionUser[] = [];
  const seen = new Set<string>();
  for (const u of byLongest) {
    const name = u.name.trim().toLowerCase();
    if (!name || seen.has(u.id)) continue;
    if (text.includes("@" + name)) {
      hit.push(u);
      seen.add(u.id);
    }
  }
  return hit;
}
